import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
  const {info: {theme}} = useContext(AppInfoContext)

  return (
    <svg
      width={20}
      height={16}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.286 6.57c.394 0 .714-.32.714-.715V2.998c0-1.183-.96-2.143-2.143-2.143H2.143C.959.855 0 1.815 0 2.998v2.857c0 .395.32.715.714.715a1.43 1.43 0 010 2.857.715.715 0 00-.714.714v2.857c0 1.184.96 2.143 2.143 2.143h15.714c1.184 0 2.143-.96 2.143-2.143v-2.857c-.007-.42-.266-.64-.714-.714a1.43 1.43 0 010-2.857zm-5-4.286v1.429a.715.715 0 01-1.429 0V2.284H2.143a.715.715 0 00-.714.714v2.233A2.86 2.86 0 013.57 7.998a2.86 2.86 0 01-2.142 2.767v2.233c0 .395.32.715.714.715h10.714v-1.429a.715.715 0 011.429 0v1.429h3.571c.394 0 .714-.32.714-.715v-2.232a2.861 2.861 0 01-2.142-2.768c0-1.33.911-2.449 2.142-2.767V2.998a.715.715 0 00-.714-.714h-3.571zM12.857 6.57v2.857a.715.715 0 001.429 0V6.57a.715.715 0 00-1.429 0z"
        fill={theme["#0D968F"]}
      />
    </svg>
  )
}
  
  export default SvgComponent